import BlogDetails from "../components/section/blog/blogDetails/BlogDetails";

const Blogs = () => {
  return (
    <>
      <BlogDetails />
    </>
  );
};

export default Blogs;
